import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";
import borrowApi from "./borrowApi";

export const getBorrow = createThunkFromApi(
  "borrow/getBorrow",
  borrowApi.getBorrow
);

export const getBorrowAmountMax = createThunkFromApi(
  "borrow/getBorrowAmountMax",
  borrowApi.getBorrowAmountMax
);

export const borrowInsert = createThunkFromApi(
  "borrow/borrowInsert",
  borrowApi.borrowInsert
);

const initialState = {
  borrowAmountMax: null,
  borrowInitial: null
};

export const borrowSlice = createSlice({
  name: "borrow",
  initialState,

  extraReducers: {
    [getBorrow.fulfilled]: (state, { payload }) => {
      state.borrowInitial = payload.data;
    },
    
    [getBorrowAmountMax.fulfilled]: (state, { payload }) => {
      state.borrowAmountMax = payload.data;
    },
  }
});

export default borrowSlice.reducer;
